<section class="feature-page">
    <app-page-header [title]="pageTitle"></app-page-header>

    <!-- Indicador de carga -->
    <div class="feature-page__content" *ngIf="isLoading">
        <div class="loading-container">
            <mat-spinner></mat-spinner>
            <p>Cargando tipo de servicio...</p>
        </div>
    </div>

    <!-- Formulario -->
    <form *ngIf="!isLoading" [formGroup]="form" class="feature-page__content form-container has-form-actions">
        <!-- Contenido del formulario -->
        <div>
            <h3>
                <mat-icon>church</mat-icon>
                Información General
            </h3>

            <div class="form-grid form-single-column">
                <!-- Nombre -->
                <mat-form-field class="full-width">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" placeholder="ej: Regular, Juventud, etc.">
                    <mat-error *ngIf="getControl('name')?.hasError('required')">
                        El nombre es requerido
                    </mat-error>
                    <mat-error *ngIf="getControl('name')?.hasError('minlength')">
                        Mínimo 3 caracteres
                    </mat-error>
                    <mat-error *ngIf="getControl('name')?.hasError('maxlength')">
                        Máximo 100 caracteres
                    </mat-error>
                </mat-form-field>

                <!-- Descripción -->
                <mat-form-field class="full-width">
                    <mat-label>Nombre completo</mat-label>
                    <input matInput formControlName="displayName" placeholder="ej: Servicio Divino Regular">
                    <mat-error *ngIf="getControl('displayName')?.hasError('required')">
                        La descripción es requerida
                    </mat-error>
                    <mat-error *ngIf="getControl('displayName')?.hasError('minlength')">
                        Mínimo 3 caracteres
                    </mat-error>
                    <mat-error *ngIf="getControl('displayName')?.hasError('maxlength')">
                        Máximo 500 caracteres
                    </mat-error>
                </mat-form-field>

                <!-- Requerir Ofrendas -->
                <div class="checkbox-field">
                    <mat-checkbox formControlName="offeringRequired">
                        ¿Requerir reporte de ofrendas para este tipo de servicio?
                    </mat-checkbox>
                </div>

            </div>

            <div class="form-actions">
                <button mat-raised-button (click)="cancel()" [disabled]="isSaving">
                    <mat-icon>cancel</mat-icon>
                    Cancelar
                </button>
                <button mat-raised-button color="primary" (click)="saveType()" [disabled]="!form.valid || isSaving">
                    <mat-spinner *ngIf="isSaving" diameter="20" class="button-spinner"></mat-spinner>
                    <mat-icon *ngIf="!isSaving">save</mat-icon>
                    {{ isSaving ? 'Guardando...' : 'Guardar' }}
                </button>
            </div>
        </div>
    </form>
</section>
